export default __webpack_public_path__ + "static/time-and-absence-4895519d4a3c0d80c035562418c933ae.png";